import type { TFunction } from 'i18next';
import type { U3129Timesheet } from '../U3129Service';
import { validateExpenseLinesForSave } from './u3129ValidateExpenseLines';
import { validateEquipmentLinesForSave } from './u3129ValidateEquipmentLines';
import { validateHonorariaLinesForSave } from './u3129ValidateHonorariaLines';

const NS = 'u3129';

export type U3129CollectTimesheetFormErrorsOptions = {
  admIncludeSubProjectEnabled?: boolean;
  /** BL-0675 : ne pas valider lignes dépense/équipement si onglets masqués. */
  hideExpenseAndEquipmentTabs?: boolean;
};

export function u3129CollectTimesheetFormErrors(
  data: U3129Timesheet,
  t: TFunction,
  opts: U3129CollectTimesheetFormErrorsOptions = {},
): Record<string, string> {
  const errors: Record<string, string> = {};
  if (!data.employeeId?.trim()) {
    errors.employeeId = t('errEmployeeRequired', { ns: NS, defaultValue: 'Employé requis.' });
  }
  if (!data.periodDate?.trim()) {
    errors.periodDate = t('errPeriodDateRequired', { ns: NS, defaultValue: 'Période requise.' });
  }
  const subprojectSaveOpts = { admIncludeSubProjectEnabled: opts.admIncludeSubProjectEnabled };
  Object.assign(
    errors,
    validateHonorariaLinesForSave(
      data,
      {
        project: t('errHonorariumProjectRequired', { ns: NS, defaultValue: 'Projet requis pour chaque ligne d’honoraires.' }),
        subproject: t('errHonorariumSubprojectRequired', { ns: NS, defaultValue: 'Sous-projet requis pour cette ligne.' }),
        task: t('errHonorariumTaskRequired', { ns: NS, defaultValue: 'Tâche requise pour chaque ligne d’honoraires.' }),
      },
      subprojectSaveOpts,
    ),
  );
  if (!opts.hideExpenseAndEquipmentTabs) {
    Object.assign(
      errors,
      validateExpenseLinesForSave(
        data,
        {
          transactionDate: t('errExpenseDateRequired', { ns: NS, defaultValue: 'Date requise pour chaque ligne de dépense.' }),
          project: t('errExpenseProjectRequired', { ns: NS, defaultValue: 'Projet requis pour chaque ligne de dépense.' }),
          subproject: t('errExpenseSubprojectRequired', { ns: NS, defaultValue: 'Sous-projet requis pour cette ligne.' }),
          expenseType: t('errExpenseTypeRequired', { ns: NS, defaultValue: 'Type de dépense requis.' }),
          taxRate: t('errExpenseTaxRateRequired', { ns: NS, defaultValue: 'Taux de taxe requis.' }),
          quantity: t('errExpenseQuantityRequired', { ns: NS, defaultValue: 'Quantité requise (nombre entier).' }),
          amount: t('errExpenseAmountRequired', { ns: NS, defaultValue: 'Montant requis (supérieur à 0).' }),
        },
        subprojectSaveOpts,
      ),
    );
    Object.assign(
      errors,
      validateEquipmentLinesForSave(
        data,
        {
          transactionDate: t('errEquipmentDateRequired', { ns: NS, defaultValue: 'Date requise pour chaque ligne d’équipement.' }),
          project: t('errEquipmentProjectRequired', { ns: NS, defaultValue: 'Projet requis pour chaque ligne d’équipement.' }),
          subproject: t('errEquipmentSubprojectRequired', { ns: NS, defaultValue: 'Sous-projet requis pour cette ligne.' }),
          equipmentType: t('errEquipmentTypeRequired', { ns: NS, defaultValue: "Type d'équipement requis." }),
          quantity: t('errEquipmentQuantityRequired', { ns: NS, defaultValue: 'Quantité requise (nombre entier).' }),
        },
        subprojectSaveOpts,
      ),
    );
  }
  return errors;
}
